import { render, staticRenderFns } from "./DashboardComparativoPage.vue?vue&type=template&id=5b1093ba&scoped=true"
import script from "./DashboardComparativoPage.vue?vue&type=script&lang=js"
export * from "./DashboardComparativoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1093ba",
  null
  
)

export default component.exports